import { useContext } from 'react'

import { InitActionsContext } from '../context'

/**
 * Init-data actions. `resetApp` clears the bootstrap data, which unmounts the
 * whole app tree behind InitProvider and triggers a full re-bootstrap (used on
 * login/logout).
 */
export function useInitActions() {
  return useContext(InitActionsContext)
}
